module.exports = __webpack_public_path__ + "img/line_path.5680ab3a.png";